const SESSION_EXPIRED_PATTERN = /session has expired/i;

export const isAdyenSessionExpiredError = (error) => {
	if (typeof error === 'string') {
		return SESSION_EXPIRED_PATTERN.test(error);
	}

	if (!error || typeof error.message !== 'string') {
		return false;
	}

	return SESSION_EXPIRED_PATTERN.test(error.message);
};

export const runWithAdyenSessionRetry = async (callback, options = {}) => {
	try {
		return await callback({ isRetry: false });
	} catch (error) {
		if (!isAdyenSessionExpiredError(error)) {
			throw error;
		}

		if (typeof options.onRetry === 'function') {
			options.onRetry(error);
		}

		return callback({ isRetry: true });
	}
};
